import { render, staticRenderFns } from "./UploadImage.v2.vue?vue&type=template&id=55e97178&"
import script from "./UploadImage.v2.vue?vue&type=script&lang=js&"
export * from "./UploadImage.v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports